import { render, staticRenderFns } from "./EnemGradesForm.vue?vue&type=template&id=157e0e0a&scoped=true&"
import script from "./EnemGradesForm.vue?vue&type=script&lang=ts&"
export * from "./EnemGradesForm.vue?vue&type=script&lang=ts&"
import style0 from "./EnemGradesForm.vue?vue&type=style&index=0&id=157e0e0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e0e0a",
  null
  
)

export default component.exports